const convert = require('xml-js');

interface WMSInfo {
  WMT_MS_Capabilities: {
    Capability: {
      Layer: {
        LatLonBoundingBox: {
          _attributes: {
            maxx: string,
            maxy: string,
            minx: string,
            miny: string,
          }
        }
        Layer: {
          Title: {
            _text: string
          }
        }
      }
    }
  }
}

export function fetchWMSTileLayoutInformation(wmsTileLayerUrl: string):Promise<{url: string, bounds: [number, number][], layerName: string}>{
  const infoUrl = `${wmsTileLayerUrl}${wmsTileLayerUrl.endsWith('?') ? '' : '?'}request=GetCapabilities`;
  return fetch(infoUrl)
    .then((res) => res.text())
    .then((res) => {
      const wmsInfo = JSON.parse(convert.xml2json(res, {compact: true})) as WMSInfo
      const layerName = wmsInfo.WMT_MS_Capabilities.Capability.Layer.Layer.Title._text;
      const {maxx, maxy, minx, miny} = wmsInfo.WMT_MS_Capabilities.Capability.Layer.LatLonBoundingBox._attributes;
      return {
        url: wmsTileLayerUrl,
        bounds: [
          [parseFloat(miny), parseFloat(minx)] as [number, number],
          [parseFloat(maxy), parseFloat(maxx)] as [number, number]
        ],
        layerName,
      }
    })
}



// WEBPACK FOOTER //
// ./src/redux/effects/wms-info.ts